import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

function FAQ({ faqs }) {
  const [openIndex, setOpenIndex] = useState(0);

  if (!faqs?.length) return null;

  return (
    <section
      id="faq"
      className="section-space bg-snow/60"
      aria-labelledby="faq-heading"
      data-aos="fade-up"
    >
      <div className="section-wrap grid grid-cols-1 gap-12 md:grid-cols-12">
        <div className="md:col-span-4">
          <p className="meta-label">06 / FAQ</p>
          <h2
            id="faq-heading"
            className="mt-4 font-display text-4xl font-bold uppercase leading-[0.86] tracking-[-0.03em] md:text-5xl"
          >
            Common
            <br />
            Questions
          </h2>
          <p className="copy-refined mt-5 max-w-xs text-sm text-ink/70">
            Quick answers about freelance work, scope, timeline, and support.
          </p>
        </div>

        <ul className="md:col-span-8" role="list">
          {faqs.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <li
                key={item.q}
                className="border-b border-ink/12 last:border-b-0"
              >
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => setOpenIndex(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 py-4 text-left transition-colors hover:text-accent md:gap-6 md:py-6"
                >
                  <span className="font-display text-base font-semibold uppercase leading-tight tracking-[-0.01em] sm:text-lg md:text-2xl">
                    {item.q}
                  </span>
                  <motion.span
                    animate={{ rotate: isOpen ? 45 : 0 }}
                    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                    className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-ink/20 text-base md:h-9 md:w-9 md:text-lg"
                    aria-hidden="true"
                  >
                    +
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen ? (
                    <motion.div
                      key="answer"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="copy-refined pb-5 pr-10 text-sm text-ink/74 md:pb-6 md:pr-12 md:text-base">{item.a}</p>
                    </motion.div>
                  ) : null}
                </AnimatePresence>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}

export default FAQ;
